<script>
import { api } from "@/store/modules/configuration";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    listConfigActivePageSize: -1,
    listConfigPage: 1,
    cachedListConfigSortBy: undefined,
    cachedListConfigDescending: undefined
  }),
  computed: {
    listConfigConfigKey() {
      console.error(
        "[warn] computed property listConfigConfigKey must be overwritten in the parent component"
      );
      return undefined;
    },
    listConfigTotalItemCount() {
      console.error(
        "[warn] computed property listConfigTotalItemCount must be overwritten in the parent component"
      );
      return undefined;
    },

    ...mapGetters(api.namespace, [api.getters.getConfigurationForList]),
    listConfigPaginationRequired() {
      return this.listConfigTotalItemCount > this.listConfigMinPageSize;
    },
    listConfig() {
      return this.getConfigurationForList(this.listConfigConfigKey);
    },
    listConfigPageSizes() {
      return this.listConfig.pageSizes;
    },
    listConfigMinPageSize() {
      return this.listConfigPageSizes
        .filter(v => Number.isInteger(v))
        .reduce((i, v) => Math.min(i, v), Number.MAX_SAFE_INTEGER);
    },
    listConfigItemsJs() {
      return this.listConfig.itemsjs;
    },
    listConfigSortBy: {
      get() {
        if (typeof this.cachedListConfigSortBy === "undefined") {
          if (
            this.listConfigItemsJs &&
            this.listConfigItemsJs.sortings &&
            this.listConfigItemsJs.sortings.name_asc
          ) {
            return this.listConfigItemsJs.sortings.name_asc.field;
          } else {
            return "name";
          }
        } else {
          return this.cachedListConfigSortBy;
        }
      },
      set(val) {
        this.cachedListConfigSortBy = val;
      }
    },
    listConfigDescending: {
      get() {
        if (typeof this.cachedListConfigDescending === "undefined") {
          if (
            this.listConfigItemsJs &&
            this.listConfigItemsJs.sortings &&
            this.listConfigItemsJs.sortings.name_asc
          ) {
            return this.listConfigItemsJs.sortings.name_asc.order === "desc";
          } else {
            return false;
          }
        } else {
          return this.cachedListConfigDescending;
        }
      },
      set(val) {
        this.cachedListConfigDescending = val;
      }
    },
    listConfigManipulator() {
      return this.listConfig.manipulators;
    },
    listConfigPaginationDataTable: {
      get() {
        return {
          rowsPerPage: this.listConfigPageSize,
          page: this.listConfigPage,
          descending: this.listConfigDescending,
          sortBy: this.listConfigSortBy
        };
      },
      set(Val) {
        this.listConfigSortBy = Val.sortBy;
        this.listConfigDescending = Val.descending;
      }
    },
    listConfigPageSize() {
      const val =
        this.listConfigActivePageSize < 0
          ? this.listConfigPageSizes[0]
          : this.listConfigPageSizes[this.listConfigActivePageSize];
      if (val === null) {
        return this.listConfigTotalItemCount;
      } else {
        return val;
      }
    },
    listConfigPageCount() {
      if (this.listConfigPageSize) {
        return Math.max(
          Math.ceil(this.listConfigTotalItemCount / this.listConfigPageSize),
          1
        );
      } else {
        return 1;
      }
    }
  },
  methods: {
    listConfigOnPaginationChange(value) {
      this.listConfigPage = value.page;
      this.listConfigActivePageSize = this.listConfigPageSizes.findIndex(
        v => v == value.pageSize
      );
      this.$vuetify.goTo("#paginationstart", { duration: 0 });
    }
  }
};
</script>
